import { ReactNode } from "react";
import { LucideIcon } from "lucide-react";
import Link from "next/link";
import { Button } from "@/app/components/shadcn/button";

interface EmptyStateAction {
  label: string;
  href?: string;
  onClick?: () => void;
  variant?: "default" | "outline" | "ghost";
}

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  actions?: EmptyStateAction[];
  children?: ReactNode;
  className?: string;
}

const EmptyState = ({
  icon: Icon,
  title,
  description,
  actions,
  children,
  className = "",
}: EmptyStateProps) => {
  return (
    <div className={`flex flex-col items-center justify-center py-12 lg:py-16 px-4 ${className}`}>
      {Icon && (
        <div className="mb-4 lg:mb-6">
          <Icon className="w-16 h-16 lg:w-20 lg:h-20 text-gray-300" strokeWidth={1.5} />
        </div>
      )}
      
      <h2 className="text-xl lg:text-2xl font-semibold text-gray-900 mb-2 text-center">
        {title}
      </h2>
      
      {description && (
        <p className="text-sm lg:text-base text-gray-500 text-center max-w-md mb-6 lg:mb-8">
          {description}
        </p>
      )}
      
      {children}
      
      {actions && actions.length > 0 && (
        <div className="flex flex-col sm:flex-row gap-3 mt-6 lg:mt-8 w-full sm:w-auto">
          {actions.map((action, index) => (
            action.href ? (
              <Button
                key={index}
                variant={action.variant || "default"}
                asChild
                className="w-full sm:w-auto"
              >
                <Link href={action.href}>{action.label}</Link>
              </Button>
            ) : (
              <Button
                key={index}
                variant={action.variant || "default"}
                onClick={action.onClick}
                className="w-full sm:w-auto"
              >
                {action.label}
              </Button>
            )
          ))}
        </div>
      )}
    </div>
  );
};

export default EmptyState;